export default "__VITE_ASSET__acd538ef__"